<template>
  <v-layout row wrap align-start align-content-start class="mb-2">
    <!-- Title and Actions -->
    <v-flex xs12 class="py-0">
      <v-toolbar tabs color="secondary" class="elevation-0">
        <v-icon class="mr-0 indigo--text text--lighten-5">account_circle</v-icon>
        <v-toolbar-title class="white--text subheading ttu">
          {{ messages.label.PROVIDER_LIST }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn color="accent" flat @click="showAddProvider">
          <v-icon left>add_circle</v-icon>
          <span>{{ messages.label.ADD_PROVIDER }}</span>
        </v-btn>
      </v-toolbar>
    </v-flex>
    <v-layout>
      <!-- Providers List -->
      <v-flex xs8>
        <ProviderList />
      </v-flex>
      <!-- Provider Group Sheet -->
      <v-flex xs4 class="side-sheet-container mr-2">
        <ProviderDetails />
      </v-flex>
    </v-layout>
    <!-- Snackbar -->
    <v-flex xs12>
      <v-snackbar :bottom="true" :timeout="snackbar.timeout" :color="snackbar.color" v-model="snackbar.show">
        {{ snackbar.message }}
        <v-btn flat color="primary" @click.native="snackbar.show = false">
          {{ messages.label.OK }}
        </v-btn>
      </v-snackbar>
    </v-flex>
  </v-layout>
</template>

<script>
import ProviderDetails from "@/Providers/ProviderList/ProviderDetails"
import ProviderList from "@/Providers/ProviderList/ProviderList"
import ProvidersService from "@/Providers/ProvidersService"
import messages from "@/Providers/messages.json"
import AppService from "@/AppService"

/**
 * initialData
 */
function initialData() {
  return {
    sideSheetVisible: false,
    snackbar: {
      show: false,
      timeout: 6000,
      message: "",
      color: ""
    }
  }
}

export default {
  name: "ProvidersListHome",
  components: {
    ProviderDetails,
    ProviderList
  },
  data: function () {
    return initialData(this)
  },
  methods: {
    /**
     * reset
     */
    reset() {
      Object.assign(this.$data, initialData(this))
    },

    /**
     * Display side sheet to add a new provider
     */
    showAddProvider() {
      this.sideSheetVisible = true
      ProvidersService.$emit("event:showProviderDetailsSheet")
    }
  },
  created() {
    /**
     * Non reactive properties
     */
    this.messages = messages
    /**
     * Events
     * */
    AppService.$on("event:preIngestServerError", () => {
      this.snackbar.show = true
      this.snackbar.color = "error"
      this.snackbar.message = this.messages.error.SERVER_ERROR
    })
    ProvidersService.$on("event:hideProviderDetailsSheet", () => {
      this.sideSheetVisible = false
    })
    ProvidersService.$on("event:showProviderDetailsSheet", () => {
      this.sideSheetVisible = true
    })
    ProvidersService.$on("event:providerAdded", () => {
      this.snackbar.show = true
      this.snackbar.color = "success"
      this.snackbar.message = this.messages.info.PROVIDER_CREATE_SUCCESS
      this.sideSheetVisible = false
    })
    ProvidersService.$on("event:providerUpdated", () => {
      this.snackbar.show = true
      this.snackbar.color = "success"
      this.snackbar.message = this.messages.info.PROVIDER_UPDATE_SUCCESS
      this.sideSheetVisible = false
    })
    ProvidersService.$on("event:providerDeleted", () => {
      this.snackbar.show = true
      this.snackbar.color = "success"
      this.snackbar.message = this.messages.info.PROVIDER_DELETE_SUCCESS
      this.sideSheetVisible = false
    })
    AppService.$on("event:mpxAccountChanged", this.reset)
  },
  beforeDestroy() {
    AppService.$off("event:mpxAccountChanged", this.reset)
  }
}
</script>

<style lang="scss">
.side-sheet-container {
  align-self: stretch;
}
</style>



// WEBPACK FOOTER //
// src/Providers/ProviderList/ProviderListHome.vue